/**
 * 生词条目业务逻辑钩子
 * 提供生词条目组件所需的所有业务逻辑
 */
import { useState, useMemo } from 'react';
/**
 * 生词条目业务逻辑钩子
 * @param item 生词数据
 * @param onDelete 删除回调
 * @returns 业务逻辑结果
 */
export function useVocabularyItemLogic(item, onDelete) {
    // 状态
    const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
    const [showTranslationDetails, setShowTranslationDetails] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState(null);
    // 格式化时间戳为可读格式
    const formatDate = (timestamp) => {
        return new Date(timestamp).toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    };
    // 处理删除操作
    const handleDelete = async () => {
        if (window.confirm(`Are you sure you want to delete "${item.originalText}"?`)) {
            setIsDeleting(true);
            setDeleteError(null);
            try {
                if (typeof item.orderId === 'number') {
                    await onDelete(item.orderId);
                }
            }
            catch (error) {
                console.error('删除生词失败:', error);
                setDeleteError('Failed to delete vocabulary. Please try again later.');
            }
            finally {
                setIsDeleting(false);
            }
        }
    };
    // 尝试解析翻译详情
    const translationDetails = useMemo(() => {
        if (item.translatedText && typeof item.translatedText === 'object') {
            const response = item.translatedText;
            // 确保优先使用 analysis 内部的字段
            const direct = response.analysis?.directTranslation;
            const context = response.analysis?.contextualMeaning;
            const grammar = response.analysis?.grammar;
            // 如果 analysis 内部字段不存在，尝试使用顶层 translatedText 作为直译
            const fallbackDirect = typeof response.translatedText === 'string' ? response.translatedText : 'N/A';
            return {
                direct: direct || fallbackDirect,
                context: context || 'N/A',
                grammar: grammar || 'N/A',
            };
        }
        // 如果 translatedText 是字符串，将其视为直译
        if (typeof item.translatedText === 'string') {
            return {
                direct: item.translatedText,
                context: 'N/A',
                grammar: 'N/A',
            };
        }
        return null;
    }, [item.translatedText]);
    return {
        // 状态
        isDetailsExpanded,
        showTranslationDetails,
        isDeleting,
        deleteError,
        // 数据
        translationDetails,
        // 方法
        formatDate,
        toggleDetails: () => setIsDetailsExpanded(!isDetailsExpanded),
        toggleTranslation: () => setShowTranslationDetails(!showTranslationDetails),
        handleDelete,
        clearDeleteError: () => setDeleteError(null),
    };
}
//# sourceMappingURL=useVocabularyItemLogic.js.map